module.exports = __webpack_public_path__ + "static/media/Link.bcb4cbd2.svg";